import ResourceCard from './ResourceCard';
import ResourceList from './ResourceList';
import ResourceLibrary from './ResourceLibrary';
import { DesktopMenu, MobileMenu } from './Menu';
import ResourceDownloadBtn from './ResourceDownloadBtn';
import NewsletterFormSection from './NewsletterFormSection';

const renameObjectKey = (obj, oldKey, newKey) =>
  delete Object.assign(obj, { [newKey]: obj[oldKey] })[oldKey];

const cleanupBlogObj = (blog) => {
  blog['url'] = `/blog/${blog.slug}/`;
  blog['topic'] = blog?.topics && blog?.topics?.length > 0 ? {name: blog?.topics[0]?.name} : null;

  renameObjectKey(blog, 'featuredImage', 'cardImage');
  renameObjectKey(blog, 'featuredImageUrl', 'cardImageUrl');
  renameObjectKey(blog, 'featuredImageAltText', 'externalCardImageAltText');

  delete blog['slug'];
  delete blog['topics'];

  return blog;
};

const cleanupResources = (resources) => {
  let miscResources = [];
  resources.nodes.map((resource) => {
    miscResources.push(resource);
  });
  return miscResources;
};

export {
  DesktopMenu,
  MobileMenu,
  ResourceCard,
  ResourceLibrary,
  ResourceList,
  ResourceDownloadBtn,
  cleanupResources,
  cleanupBlogObj,
  NewsletterFormSection
};
